import React from 'react';
import ResourceShareDialog from '../shared/ResourceShareDialog';

const ShareAgentDialog = ({ open, agent, onClose, onSuccess }) => (
  <ResourceShareDialog
    open={open}
    resource={agent ? { type: 'agent', id: agent.id, name: agent.name } : null}
    onClose={onClose}
    onSuccess={onSuccess}
  />
);

export default ShareAgentDialog;
